module.exports = __webpack_public_path__ + "img/chma.59a433ca.jpg";